// Init sessionStorage
if (!sessionStorage.getItem('session_started_sidecart_returning')) {
  sessionStorage.setItem('session_started_sidecart_returning', 'true');
}

// Function to toggle hidden class
const handleClass = (selector, selectorClass) => {
  const item = document.querySelectorAll(selector);
  if (item) {
    item.forEach((element) => {
      element.classList.toggle(selectorClass);
    });
  }
};

// Function to change the position of elements
const handlePosition = (element, position) => {
  const elementToMove = document.querySelector(element);
  const positionElement = document.querySelector(position);
  if (elementToMove && positionElement) {
    positionElement.insertAdjacentElement("afterend", elementToMove);
  }
};

//function style for minicart
function styleMinicart(selector) {
  const minicart = document.querySelector(selector);
  if (minicart) {
    if (window.matchMedia("(max-width: 550px)").matches) {
      Object.assign(minicart.style, {
        width: '330px',
        height: '500px',
        maxWidth: '100%',
        borderRadius: '10px',
        top: '10%',
        right: '50%',
        transform: 'translateX(50%)',
        backgroundColor: '#FFFFFF',
        important: true,
      });
    } else {
      Object.assign(minicart.style, {
        width: '570px',
        height: '500px',
        maxWidth: '100%',
        borderRadius: '10px',
        top: '40px',
        right: '40px',
        backgroundColor: '#FFFFFF',
        important: true,
      });
    }
  }
}

//function click element

function clickElement(selector) {
  const element = document.querySelector(selector);
  if (element) {
    element.click();
  }
}

// Function to observe minicart and apply styles
function observeMinicart() {
  const minicart = document.querySelector('.minicart');

  if (!minicart) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'class') {
        if (!minicart.classList.contains('active')) {

          minicart.removeAttribute('style');

          // handlePosition('.minicart__actions', '.minicart__container-sticky');

          handleClass('.minicart-recommended', 'hidden-class');
          handleClass('.minicart__header-title', 'hidden-class');
          handleClass('.minicart__terms', 'hidden-class');
          handleClass('.minicart__total', 'hidden-class');
          handleClass('.minicart-bag__count','minicart-bag__count-returning')
          handleClass('.minicart__continue-shopping', 'view-class-grid');
          handleClass('.minicart__checkout', 'minicart__proceed-checkout');
          handleClass('.minicart__header-title-returning-cart', 'view-class');
          handleClass('.minicart__actions', 'minicart__actions-returning');

          observer.disconnect();
        }
      }
    });
  });

  observer.observe(minicart, { attributes: true, attributeFilter: ['class'] });
}

if ((sessionStorage.getItem('session_started_sidecart_returning') === 'true')) {

  fetch(window.Shopify.routes.root + 'cart.js')
    .then((response) => response.json())
    .then((cart) => {
      if (cart.items.length > 0) {

        styleMinicart('.minicart');
  
        // handlePosition('.minicart__actions', '.minicart__item-list');
      
        handleClass('.minicart-recommended', 'hidden-class');
        handleClass('.minicart__header-title', 'hidden-class');
        handleClass('.minicart__terms', 'hidden-class');
        handleClass('.minicart__total', 'hidden-class');
        handleClass('.minicart__image-wrap', 'minicart__heigth')
        handleClass('.minicart__image-wrap img', 'minicart__heigth')
        handleClass('.minicart-bag__count','minicart-bag__count-returning')
        handleClass('.minicart__continue-shopping', 'view-class-grid');
        handleClass('.minicart__checkout', 'minicart__proceed-checkout');
        handleClass('.minicart__header-title-returning-cart', 'view-class');
        handleClass('.minicart__actions', 'minicart__actions-returning');
        
        observeMinicart();
        
        sessionStorage.setItem('session_started_sidecart_returning', 'false');
        
        clickElement('.header-tools__icon--cart');


        //Button Continue Shopping
        const buttonContinueShopping = document.querySelector('.minicart__continue-shopping');

        buttonContinueShopping.addEventListener('click', () => {
          clickElement('.minicart__close');
        })

      }
    })
    .catch((error) => console.error('Error al obtener el carrito:', error));
}